import React, { useEffect, useState } from 'react';
import AdminHeader from '../layout/AdminHeader';
import { getEmailHistory } from '../../actions/auth';
import Paginated from './Paginated';
import { COLUMNS } from './column';
import { getDate } from '../../utils/helper';



function History() {
    const [loader, setLoader] = useState(false);
    const [response,setResponse] = useState()
    const [formData, setFormData] = useState([]);
    const userID = localStorage.getItem("userId")
 
    const fetch = async () => {
		setLoader(true)
		await getEmailHistory(userID)
			.then((res) => {
				setResponse(res.data);
				setLoader(false)
			})
			.catch(() => {
			});
	};

	useEffect(() => {
		fetch()
	}, [])
    useEffect(() => {
		const tempData = response;
		if (tempData) {
			tempData?.map((val, ind) => {
				return (val.purpose = val.campaignName);
			});
            tempData?.map((val, ind) => {
				return (val.subject = val.subject);
			});
            tempData?.map((val, ind) => {
				return (val.fromName = val.fromName);
			});
            tempData?.map((val, ind) => {
				return (val.fromEmail = val.fromEmail);
			});
            tempData?.map((val, ind) => {
				return (val.createdAt = getDate(val.createdAt,"DD-MM-YYYY"));
			});
           
            tempData?.map((val, ind) => {
				return (val.totalSend = val.totalSend);
			});
            tempData?.map((val, ind) => {
				return (val.totalPending = val.totalPending);
			});
            tempData?.map((val, ind) => {
				return (val.totalFail = val.totalFail);
			});
			
			
		}
		setFormData(tempData);
	}, [response]);

    return (
        <div>
            <AdminHeader name={"Email History"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className='dashboard__content'>
                <div className="dashboard__transactionsCard">
                    <div className="dashboard__header">
                        <div className="dashboard__left">
                            <h4 id='transction_list'>Email History</h4>
                        </div>
                    </div>
                    <div className="dashboard__body">
							
                            <Paginated data={formData ? formData : []} columns={COLUMNS} />
                        
                        </div>
                </div>
            </div>
        </div>
    );
}

export default History;
